import Cookies from 'js-cookie'

export const setItem = function (key, data) {
  if (!data && data !== 0) return
    if (typeof data === 'string') {
      localStorage.setItem(key, data)
    } else {
      localStorage.setItem(key, JSON.stringify(data))
    }
}

export const getItem = function (key) {
  const str = localStorage.getItem(key)
    let val
    try {
      val = JSON.parse(str)
    } catch (e) {
      val = str
    }
    return val
}

export const removeItem = function (key) {
  localStorage.removeItem(key)
}

export const getToken = function () {
  return Cookies.get('userToken')
}



// WEBPACK FOOTER //
// ./src/npm/monitor/platform/h5/storage.js